var cov_2eoduswdp1 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Upload/Drop.tsx",
      hash = "4e8aca630bbc9b928483239364a410c9b7ff1fff",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Upload/Drop.tsx",
    statementMap: {
      "0": {
        start: {
          line: 16,
          column: 4
        },
        end: {
          line: 16,
          column: 16
        }
      },
      "1": {
        start: {
          line: 17,
          column: 4
        },
        end: {
          line: 19,
          column: 5
        }
      },
      "2": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 48
        }
      },
      "3": {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 21,
          column: 56
        }
      },
      "4": {
        start: {
          line: 25,
          column: 22
        },
        end: {
          line: 25,
          column: 36
        }
      },
      "5": {
        start: {
          line: 26,
          column: 51
        },
        end: {
          line: 26,
          column: 61
        }
      },
      "6": {
        start: {
          line: 27,
          column: 19
        },
        end: {
          line: 27,
          column: 106
        }
      },
      "7": {
        start: {
          line: 27,
          column: 76
        },
        end: {
          line: 27,
          column: 97
        }
      },
      "8": {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 28,
          column: 46
        }
      },
      "9": {
        start: {
          line: 28,
          column: 40
        },
        end: {
          line: 28,
          column: 46
        }
      },
      "10": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 29,
          column: 65
        }
      },
      "11": {
        start: {
          line: 29,
          column: 16
        },
        end: {
          line: 29,
          column: 65
        }
      },
      "12": {
        start: {
          line: 33,
          column: 25
        },
        end: {
          line: 33,
          column: 35
        }
      },
      "13": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 34,
          column: 24
        }
      },
      "14": {
        start: {
          line: 34,
          column: 18
        },
        end: {
          line: 34,
          column: 24
        }
      },
      "15": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 35,
          column: 22
        }
      },
      "16": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 36,
          column: 23
        }
      },
      "17": {
        start: {
          line: 37,
          column: 4
        },
        end: {
          line: 37,
          column: 50
        }
      },
      "18": {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 38,
          column: 49
        }
      },
      "19": {
        start: {
          line: 38,
          column: 27
        },
        end: {
          line: 38,
          column: 49
        }
      },
      "20": {
        start: {
          line: 42,
          column: 21
        },
        end: {
          line: 42,
          column: 31
        }
      },
      "21": {
        start: {
          line: 43,
          column: 36
        },
        end: {
          line: 43,
          column: 46
        }
      },
      "22": {
        start: {
          line: 44,
          column: 4
        },
        end: {
          line: 44,
          column: 41
        }
      },
      "23": {
        start: {
          line: 44,
          column: 26
        },
        end: {
          line: 44,
          column: 41
        }
      },
      "24": {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 54,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 15,
            column: 2
          },
          end: {
            line: 15,
            column: 3
          }
        },
        loc: {
          start: {
            line: 15,
            column: 43
          },
          end: {
            line: 22,
            column: 3
          }
        },
        line: 15
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 24,
            column: 2
          },
          end: {
            line: 24,
            column: 3
          }
        },
        loc: {
          start: {
            line: 24,
            column: 37
          },
          end: {
            line: 30,
            column: 3
          }
        },
        line: 24
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 27,
            column: 63
          },
          end: {
            line: 27,
            column: 64
          }
        },
        loc: {
          start: {
            line: 27,
            column: 76
          },
          end: {
            line: 27,
            column: 97
          }
        },
        line: 27
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 32,
            column: 2
          },
          end: {
            line: 32,
            column: 3
          }
        },
        loc: {
          start: {
            line: 32,
            column: 33
          },
          end: {
            line: 39,
            column: 3
          }
        },
        line: 32
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 41,
            column: 2
          },
          end: {
            line: 41,
            column: 3
          }
        },
        loc: {
          start: {
            line: 41,
            column: 11
          },
          end: {
            line: 55,
            column: 3
          }
        },
        line: 41
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 27,
            column: 19
          },
          end: {
            line: 27,
            column: 106
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 27,
            column: 28
          },
          end: {
            line: 27,
            column: 98
          }
        }, {
          start: {
            line: 27,
            column: 101
          },
          end: {
            line: 27,
            column: 106
          }
        }],
        line: 27
      },
      "1": {
        loc: {
          start: {
            line: 28,
            column: 4
          },
          end: {
            line: 28,
            column: 46
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 28,
            column: 4
          },
          end: {
            line: 28,
            column: 46
          }
        }, {
          start: {
            line: 28,
            column: 4
          },
          end: {
            line: 28,
            column: 46
          }
        }],
        line: 28
      },
      "2": {
        loc: {
          start: {
            line: 28,
            column: 8
          },
          end: {
            line: 28,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 28,
            column: 8
          },
          end: {
            line: 28,
            column: 15
          }
        }, {
          start: {
            line: 28,
            column: 19
          },
          end: {
            line: 28,
            column: 38
          }
        }],
        line: 28
      },
      "3": {
        loc: {
          start: {
            line: 29,
            column: 4
          },
          end: {
            line: 29,
            column: 65
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 29,
            column: 4
          },
          end: {
            line: 29,
            column: 65
          }
        }, {
          start: {
            line: 29,
            column: 4
          },
          end: {
            line: 29,
            column: 65
          }
        }],
        line: 29
      },
      "4": {
        loc: {
          start: {
            line: 29,
            column: 23
          },
          end: {
            line: 29,
            column: 54
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 29,
            column: 34
          },
          end: {
            line: 29,
            column: 40
          }
        }, {
          start: {
            line: 29,
            column: 43
          },
          end: {
            line: 29,
            column: 54
          }
        }],
        line: 29
      },
      "5": {
        loc: {
          start: {
            line: 34,
            column: 4
          },
          end: {
            line: 34,
            column: 24
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 34,
            column: 4
          },
          end: {
            line: 34,
            column: 24
          }
        }, {
          start: {
            line: 34,
            column: 4
          },
          end: {
            line: 34,
            column: 24
          }
        }],
        line: 34
      },
      "6": {
        loc: {
          start: {
            line: 38,
            column: 4
          },
          end: {
            line: 38,
            column: 49
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 38,
            column: 4
          },
          end: {
            line: 38,
            column: 49
          }
        }, {
          start: {
            line: 38,
            column: 4
          },
          end: {
            line: 38,
            column: 49
          }
        }],
        line: 38
      },
      "7": {
        loc: {
          start: {
            line: 44,
            column: 4
          },
          end: {
            line: 44,
            column: 41
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 44,
            column: 4
          },
          end: {
            line: 44,
            column: 41
          }
        }, {
          start: {
            line: 44,
            column: 4
          },
          end: {
            line: 44,
            column: 41
          }
        }],
        line: 44
      },
      "8": {
        loc: {
          start: {
            line: 47,
            column: 53
          },
          end: {
            line: 47,
            column: 67
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 47,
            column: 53
          },
          end: {
            line: 47,
            column: 57
          }
        }, {
          start: {
            line: 47,
            column: 61
          },
          end: {
            line: 47,
            column: 67
          }
        }],
        line: 47
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Upload/Drop.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import classnames from 'classnames';
import { uploadClass } from './styles';
import { accept as fileAccept } from '../utils';

var Drop =
/*#__PURE__*/
function (_ref) {
  _inherits(Drop, _ref);

  var _super = _createSuper2(Drop);

  function Drop(props) {
    var _this;

    _classCallCheck(this, Drop);

    cov_2eoduswdp1.f[0]++;
    cov_2eoduswdp1.s[0]++;
    _this = _super.call(this, props);
    cov_2eoduswdp1.s[1]++;
    _this.state = {
      drop: false
    };
    cov_2eoduswdp1.s[2]++;
    _this.handleDrag = _this.handleDrag.bind(_assertThisInitialized(_this));
    cov_2eoduswdp1.s[3]++;
    _this.handleFileDrop = _this.handleFileDrop.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Drop, [{
    key: "handleFileDrop",
    value: function handleFileDrop(e) {
      cov_2eoduswdp1.f[1]++;

      var _ref2 = (cov_2eoduswdp1.s[4]++, e.dataTransfer),
          files = _ref2.files;

      var _ref3 = (cov_2eoduswdp1.s[5]++, this.props),
          accept = _ref3.accept,
          multiple = _ref3.multiple,
          onDrop = _ref3.onDrop,
          dropData = _ref3.dropData;

      var filter = (cov_2eoduswdp1.s[6]++, accept ? (cov_2eoduswdp1.b[0][0]++, Array.prototype.filter.call(files, function (f) {
        cov_2eoduswdp1.f[2]++;
        cov_2eoduswdp1.s[7]++;
        return fileAccept(f, accept);
      })) : (cov_2eoduswdp1.b[0][1]++, files));
      cov_2eoduswdp1.s[8]++;

      if ((cov_2eoduswdp1.b[2][0]++, !filter) || (cov_2eoduswdp1.b[2][1]++, filter.length === 0)) {
        cov_2eoduswdp1.b[1][0]++;
        cov_2eoduswdp1.s[9]++;
        return;
      } else {
        cov_2eoduswdp1.b[1][1]++;
      }

      cov_2eoduswdp1.s[10]++;

      if (onDrop) {
        cov_2eoduswdp1.b[3][0]++;
        cov_2eoduswdp1.s[11]++;
        onDrop(multiple ? (cov_2eoduswdp1.b[4][0]++, filter) : (cov_2eoduswdp1.b[4][1]++, [filter[0]]), dropData);
      } else {
        cov_2eoduswdp1.b[3][1]++;
      }
    }
  }, {
    key: "handleDrag",
    value: function handleDrag(e) {
      cov_2eoduswdp1.f[3]++;

      var _ref4 = (cov_2eoduswdp1.s[12]++, this.props),
          disabled = _ref4.disabled;

      cov_2eoduswdp1.s[13]++;

      if (disabled) {
        cov_2eoduswdp1.b[5][0]++;
        cov_2eoduswdp1.s[14]++;
        return;
      } else {
        cov_2eoduswdp1.b[5][1]++;
      }

      cov_2eoduswdp1.s[15]++;
      e.preventDefault();
      cov_2eoduswdp1.s[16]++;
      e.stopPropagation();
      cov_2eoduswdp1.s[17]++;
      this.setState({
        drop: e.type === 'dragover'
      });
      cov_2eoduswdp1.s[18]++;

      if (e.type === 'drop') {
        cov_2eoduswdp1.b[6][0]++;
        cov_2eoduswdp1.s[19]++;
        this.handleFileDrop(e);
      } else {
        cov_2eoduswdp1.b[6][1]++;
      }
    }
  }, {
    key: "render",
    value: function render() {
      cov_2eoduswdp1.f[4]++;

      var _ref5 = (cov_2eoduswdp1.s[20]++, this.state),
          drop = _ref5.drop;

      var _ref6 = (cov_2eoduswdp1.s[21]++, this.props),
          children = _ref6.children,
          className = _ref6.className;

      cov_2eoduswdp1.s[22]++;

      if (!this.props.drop) {
        cov_2eoduswdp1.b[7][0]++;
        cov_2eoduswdp1.s[23]++;
        return children;
      } else {
        cov_2eoduswdp1.b[7][1]++;
      }

      cov_2eoduswdp1.s[24]++;
      return (
        /*#__PURE__*/
        React.createElement("span", {
          className: classnames(className, uploadClass((cov_2eoduswdp1.b[8][0]++, drop) && (cov_2eoduswdp1.b[8][1]++, 'drop'))),
          onDragOver: this.handleDrag,
          onDragLeave: this.handleDrag,
          onDrop: this.handleDrag,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 46,
            columnNumber: 7
          }
        }, children)
      );
    }
  }]);

  return Drop;
}((React.Component));

Drop.defaultProps = {
  drop: false
};
export { Drop as default };